export default __webpack_public_path__ + "static/media/international_equity.0e352086.svg";